import Vue from 'vue'
import Vuex from 'vuex'
import {Toast, Dialog} from "vant";
import axios from "@/utils/axios"
import Clipboard from 'clipboard';
import {getCookie, getLocalStorage} from "@/utils/common";



Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isInit: false,
    serveCode: 0,
    serveShow: "menu",
    roomId: null,
    isToday: false,
    lineTimeArray: null,
    currentTimeLine: -1,
    zeroTime: '次',
    roomLine: null,
    currentShowActive: 'show',
    search: "",
    homeCount: 0,
    searching: "",
    searchCancel: 0,
    dealFightMsg: "",
    loading: false,
    priceTabListActive: "dianwan",
    activeIcon: require("@/public/img/star.png"),
    inactiveIcon: require("@/public/img/star_bg.png"),
    priceTabList: [],
    fightData: null,
    uploadClient: "",
    roomFightData: {},
    homePicker: {
      fightTimePicker: false,
      playerNumPicker: false,
      playTimePicker: false,
      playItemPicker: false,
      roomNoPicker: false,
    },
    festival: [

    ],
    festivalArray: [

    ],
    playItemData: [

    ],
    playItemColumn: [

    ],
    publicConfig: {
      isWriteOrigin: '0',
      serviceMobile: "",
      serviceWx: "",
      serviceWxQrCode: "",
      uploadBaseUrl: 'http://upload.dustar.cn/client',
    },
    fightShow: false,
    apiStoreData: {

    },
    storeDropdownOption: [],
    storeDropdownValue: "",
    storeDropdownName: "",
    filterDropdownOption: [],
    roomSizeData: [],
    filterDropdownValue: "",
    showList: [],
    filterShowList: [],
    initArray: ['config-data', 'festival-config', 'store-list', 'room-size', 'room-list', 'price-list'],
    competedArray: [],
    playerNumColumns: [
      {text: "1人", value: 1},
      {text: "2人", value: 2},
      {text: "3人", value: 3},
      {text: "4人", value: 4},
      {text: "5人", value: 5},
      {text: "6人", value: 6},
      {text: "7人", value: 7},
      {text: "8人", value: 8},
      {text: "9人", value: 9},
      {text: "10人", value: 10},
      {text: "11人", value: 11},
      {text: "12人", value: 12},
      {text: "13人", value: 13},
      {text: "14人", value: 14},
      {text: "15人", value: 15}
    ],
    playTimeColumns: [
      {text: '1小时', value: 1},
      {text: '2小时', value: 2},
      {text: '3小时', value: 3},
      {text: '4小时', value: 4},
      {text: '5小时', value: 5},
      {text: '6小时', value: 6},
      {text: '7小时', value: 7},
      {text: '8小时', value: 8},
      {text: '9小时', value: 9},
      {text: '10小时', value: 10},
      {text: '11小时', value: 11},
      {text: '12小时', value: 12},
    ],
  },
  getters: {
  },
  mutations: {
    success(state, msg) {
      this.commit('toast', {msg: msg, type: 'success'})
    },
    fail(state, msg) {
      Dialog.alert({
        message: msg,
        theme: 'round-button',
      }).then();
    },
    toast(state, payload) {
      Toast({
        message: payload.msg,
        icon: require("@/public/img/love.png")
      });
    },
    initApp(state, $route) {

      state.loading = true;
      // 公共配置
      axios.get("/get-config-data").then(res => {
        if (res['success']) {
          for (let i in res.data) state.publicConfig[res.data[i].key] = res.data[i].value;
          state.competedArray.push('config-data');
        }
      })

      // 节日配置
      axios.get("/get-festival-config").then(res => {
        if (res['success']) {
          state.festival = res.data['festivalConfig'];
          state.festivalArray = res.data['dateArray'];
          state.competedArray.push('festival-config');
        }
      })

      axios.get("/play-item-data").then(res => {
        if (res['success']) state.playItemData = res.data;

        // 门店放到这里
        axios.get("/get-store-list").then(res => {

          if (res['success']) {

            let apiStoreData = {};
            for (let i in res.data) {
              apiStoreData[res.data[i].value] = res.data[i];
            }

            state.apiStoreData = apiStoreData;

            let count = 0;
            for (let i in state.apiStoreData) {
              let text = `${state.apiStoreData[i].name}`;
              state.storeDropdownOption.push({
                text: text,
                value: state.apiStoreData[i].value
              })

              if (count === 0) {
                state.storeDropdownValue = state.apiStoreData[i].value;
                state.storeDropdownName = text;
              }

              count++;
            }

            // 设置进入的门店
            let localStoreData = getLocalStorage("fight_data");
            let store = "";
            if ($route.query.store) {
              store = $route.query.store;
            } else if (localStoreData !=null && localStoreData.storeValue || '' !== '') {
              store = localStoreData.storeValue
            } else {
              store = "gl-ss";
            }

            if ($route.query.menu)
              state.currentShowActive = $route.query.menu;


            this.commit("storeChange", store);
            state.competedArray.push("store-list");

            // 必须放这里
            let mobile = getCookie("fight_mobile");
            if (mobile) {
              axios.get("/get-order-by-mobile/" + mobile).then(res1 => {
                if (res1['success'] && res1.data) {
                  state.fightData = res1.data;
                  this.commit("currentFightSpan", res1.data);
                }
              })
            }
          }
        })
      })


      state.filterDropdownOption.push({text: "🏠 全部规格", value:"total"});
      state.filterDropdownValue = "total";

      axios.get("/get-room-size").then(res => {
        if (res['success']) {
          for (let i in res.data) {
            state.roomSizeData = res.data;
            let text = "";

            if (res.data[i]['roomType'] === 0) {
              text = `${res.data[i].name}人包间`
            } else {
              text = res.data[i].name;
            }

            let option = {
              text: `🏠 ${text}`,
              value: i
            }

            state.filterDropdownOption.push(option);
          }

          state.competedArray.push('room-size');
        }
      })
    },
    currentFightSpan(state, data) {
      data.isEnd = true;
      this.commit("fightInfoSpan", data);

      let statusSpan = "";
      switch (data.status) {
        case 0:
          statusSpan = " (👻 待审核)"
          break;
        case 1:
          statusSpan = " (👻 审核驳回)"
          break;
        case 2:
          statusSpan = " (👻 审核通过)"
          break;
      }

      Dialog.alert({
        overlayClass: "sec-confirm",
        showCancelButton: true,
        cancelButtonText: '取消预约',
        confirmButtonText: '确认信息',
        title: '预约信息' + statusSpan,
        message: `${state.dealFightMsg}`
      }).then(() => {
        // 无事发生
      }).catch(() => {
        // 取消预约接口

        axios.get("/cancel-order/" + data.id).then((res) => {
          if (res['success']) {
            state.fightData = null;
            state.homeCount++;
            this.commit("success", "取消成功");
          } else {
            this.commit("fail", res['message']);
          }
        })
      })

      setTimeout(() => {
        let copyBtnPhone = document.querySelector("#copyBtnPhone");
        let copyBtnWx = document.querySelector("#copyBtnWx");
        new Clipboard(copyBtnPhone);
        new Clipboard(copyBtnWx);


        copyBtnPhone.onclick = () => {
          this.commit("success", "复制成功");
        }

        copyBtnWx.onclick = () => {
          this.commit("success", "复制成功");
        }

      }, 200)

    },
    isCloseLoading(state) {
      let isCloseLoading = true;
      for (let i in state.initArray)
        if (!state.competedArray.includes(state.initArray[i])) isCloseLoading = false;

      if (isCloseLoading) {
        state.loading = false;
        state.isInit = true;
      }
    },
    getRoomList(state, storeValue) {
      state.loading = true;
      axios.get(`/get-room-list/${storeValue}`).then(res => {
        if (res['success']) {
          for (let i in res.data) res.data[i].index = 0;
          state.showList = res.data;
          state.filterShowList = res.data;
          state.filterDropdownValue = 'total';

          if (!state.competedArray.includes('room-list')) {
            state.competedArray.push('room-list');
          }

          this.commit("isCloseLoading");
        }
      })
    },
    getPrice(state, storeValue) {
      state.loading = true;
      axios.get(`/get-price-table/${storeValue}`).then(res => {
        if (res['success']) {
          state.priceTabList = res.data;
          state.priceTabList[0].name;
          if (!state.competedArray.push('price-list')) {
            state.competedArray.push('price-list');
          }

          this.commit("isCloseLoading");
        }
      })
    },
    storeChange(state, item) {
      state.roomId = null;
      for (let i in state.storeDropdownOption) {
        if (state.storeDropdownOption[i].value === item) {
          state.storeDropdownValue = item;
          state.storeDropdownName = state.storeDropdownOption[i].text;

          this.commit("getRoomList", item);
          this.commit("getPrice", item);
          this.commit("dealPlayItemData", state.playItemData);
        }
      }
    },
    dealPlayItemData(state, data) {
      state.playItemColumn = [];
      for (let i in data) {
        let text = data[i].value.replace(/{playerNum}/g, state.apiStoreData[state.storeDropdownValue]['tablePlayerNum']);
        let json = {
          text,
          value: data[i].key
        }

        state.playItemColumn.push(json)
      }
    },
    fightInfoSpan(state, data) {
      let calendarValue = data.calendarValue;
      if (typeof calendarValue === "string") calendarValue = new Date(calendarValue);
      let year = calendarValue.getFullYear();
      let month = String(calendarValue.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需加1，并确保两位数
      let day = String(calendarValue.getDate()).padStart(2, '0'); // 确保日期为两位数
      let weekend = [0, 6];
      let isDayCrowed = state.festivalArray.includes(`${year}-${month}-${day}`) || weekend.includes(calendarValue.getDay());

      let hour = data.fightTimeValue.split(":")[0];
      let isHourCrowed = hour >= 12 && hour <= 18;

      let crowedSpan = "";
      let storeShow = data.storeShow;

// 预约须知
// 1、节假日下午时段原则上需按预约的时间到场开始-结束，如个人原因迟到的，该包间后续有其他预约则按照预约的结束时间结束，无其他预约的可按实际时间结束。
// 2、节假日下午时段预约，美团/抖音下单后需提供二维码发给客服，核销审核后才算预约成功，不可退订，不可更换场次。
// 3、节假日下午时段不可指定包间，只能尽可能满足，如有主题强需求的客人请更换包间时间。

      if (isDayCrowed && isHourCrowed) {
        crowedSpan =  `
         <p class="item-bold">
         ✨ <span class="point">节假日下午时段</span>预约,<span class="point">美团/抖音/微信提前下单并将核销码发给客服。</span>。
         </p>
         <p class="item-bold">
         ✨ <span class="point">节假日下午时段</span>预约,<span class="point">不可退订退款</span>，可更换至当天非高峰时段，一般为晚间6点后。
         预约时段包间始终为您预留。
         </p>
         <p class="item-bold">
         ✨ 如当前包间有<span class="point">下一时段其他预约</span>，需<span class="point">按当前预约的结束时间</span>结束体验，无法续时。
         </p>
         `
      }

      let timeRangeValue = data.timeRangeValue.split(" - ");
      let beginTime  = timeRangeValue[0].split(" ")[1];
      let endTime = timeRangeValue[1].split(" ")[1];

      let notice = "";
      let kf = "";
      let serveCode = "";
      if (data.isEnd) {
        notice =
         `<p class="item-bold">
         ✨ 注意事项: 确认预约后需<span class="point">告知客服</span>，
         客服后台<span class="point">审核</span>后才算<span class="point">预约成功</span>!
        </p>`;

        serveCode = `<p class="item-bold">👾 服务码: ${data.id}${data['serveCode']}</p>`;

        kf = `<p class="item-bold">
        📲 客服手机:
        <span id="copyBtnWx"
        data-clipboard-text="${state.apiStoreData[state.storeDropdownValue]['mobile']}"
        >${state.apiStoreData[state.storeDropdownValue]['mobile']}</span>
        <a class="point" href="tel:${state.apiStoreData[state.storeDropdownValue]['mobile']}">拨打</a>
        </p>
        <p class="item-bold">
        🛰️ 客服微信: ${state.apiStoreData[state.storeDropdownValue]['wxNum']}
        <span class="copyBtn"  id="copyBtnPhone"
        data-clipboard-text="${state.apiStoreData[state.storeDropdownValue]['wxNum']}"
        >复制</span>

        <div style="text-align: center">
          <span class="item-bold" style="font-size: 14px">长按识别或保存客服二维码</span>
          <img src="${state.publicConfig.uploadBaseUrl}${state.apiStoreData[state.storeDropdownValue]['wxKfUrl']}"
          style="width: 100%;margin-top: 5px" alt="">
        </div>
        </p>
        `
      }

      let payStr = ``;
      // if (data.playItemValue !== 'dt_diy')
      //   payStr = `<p class="item-bold">💰 支付方式: ${data.payShow}</p>`;

      state.dealFightMsg = `
        ${notice}
        ${crowedSpan}
        ${serveCode}
        <p class="item-bold">📍 游玩门店: ${storeShow}</p>
        <p class="item-bold">📱 手机号: ${data.mobile}</p>
        <p class="item-bold">👻 游玩人数: ${data.playerNumShow}</p>
        <p class="item-bold">📅 游玩日期: ${data.calendarShow}</p>
        <p class="item-bold">⌚️ 游玩时段: ${beginTime} - ${endTime}</p>
        <p class="item-bold">🏠 意向包间: ${data.likeRoomShow}</p>
        ${payStr}
        <p class="item-bold">📒 备注: ${data.note}</p>
        ${kf}`

    },



  },
  actions: {
  },
  modules: {
  }
})
